import * as React from "react";

import {
	Edit,
	SimpleForm,
	EditProps,
	BooleanInput,
	TextInput,
	ReferenceInput,
	SelectInput,
	regex,
} from "react-admin";

import { DoctorSaleTitle } from "../doctorSale/DoctorSaleTitle";
import labelsTranslation from "../translations/tranlation";

const validatePatientCreation = (values: any) => {
	const errors: any = {};
	if (!values.firstName) {
		errors.firstName = "لطفا نام را وارد نمایید";
	}
	if (!values.mobile) {
		errors.mobile = "لطفا شماره موبایل را وارد نمایید";
	}
	if (!values.lastName) {
		errors.lastName = "لطفا نام خانوادگی را وارد نمایید";
	}
	if (!values.doctorComment) {
		errors.doctorComment = "لطفا توضیحات را وارد نمایید";
	}
	return errors;
};

const validateMobile = regex(
	/^((0)9\d{9})$/,
	"شماره موبایل را صحیح وارد نماید"
);

export const PatientEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit title={labelsTranslation.userEdit.title} {...props}>
			<SimpleForm validate={validatePatientCreation}>
				{/* <BooleanInput label="Archived" source="archived" /> */}
				<TextInput
					label={labelsTranslation.userCreate.fName}
					source="firstName"
				/>
				<TextInput
					label={labelsTranslation.userCreate.lName}
					source="lastName"
				/>
				<TextInput
					label={labelsTranslation.userCreate.mobile}
					validate={validateMobile}
					source="mobile"
				/>
				<TextInput
					label={labelsTranslation.userCreate.comment}
					multiline
					source="doctorComment"
				/>
				{/* <TextInput label="Doctor Id" source="doctorId" />
				<ReferenceInput
					source="doctorsale.id"
					reference="DoctorSale"
					label="Doctor Sale"
				>
					<SelectInput optionText={DoctorSaleTitle} />
				</ReferenceInput>

				<TextInput
					label="Sale Representative Comment"
					multiline
					source="saleRepresentativeComment"
				/> */}
			</SimpleForm>
		</Edit>
	);
};
